'use client';

import { useFormState, useFormStatus } from 'react-dom';

import { Button } from '~/components/ui/button';
import { Input } from '~/components/ui/input';
import { Label } from '~/components/ui/label';
import { type ActionState, registerAction } from '~/lib/auth/actions';

const initialState: ActionState = {};

export function RegisterForm() {
  const [state, formAction] = useFormState(registerAction, initialState);

  return (
    <form action={formAction} className="mt-8 space-y-4">
      <Field
        id="name"
        name="name"
        type="text"
        label="Your name"
        autoComplete="name"
        required
        error={state.fieldErrors?.name}
      />
      <Field
        id="organizationName"
        name="organizationName"
        type="text"
        label="Organization"
        autoComplete="organization"
        required
        error={state.fieldErrors?.organizationName}
      />
      <Field
        id="email"
        name="email"
        type="email"
        label="Email"
        autoComplete="email"
        required
        error={state.fieldErrors?.email}
      />
      <Field
        id="password"
        name="password"
        type="password"
        label="Password"
        autoComplete="new-password"
        required
        minLength={8}
        error={state.fieldErrors?.password}
        hint="At least 8 characters."
      />

      {state.error ? (
        <p className="text-xs text-[color:var(--color-error)]">{state.error}</p>
      ) : null}

      <Submit />
    </form>
  );
}

function Submit() {
  const { pending } = useFormStatus();
  return (
    <Button type="submit" variant="primary" className="w-full" disabled={pending}>
      {pending ? 'Creating account…' : 'Create account'}
    </Button>
  );
}

function Field({
  id,
  name,
  type,
  label,
  autoComplete,
  required,
  minLength,
  error,
  hint,
}: {
  id: string;
  name: string;
  type: string;
  label: string;
  autoComplete?: string | undefined;
  required?: boolean | undefined;
  minLength?: number | undefined;
  error?: string | undefined;
  hint?: string | undefined;
}) {
  return (
    <div className="space-y-1.5">
      <Label htmlFor={id}>{label}</Label>
      <Input
        id={id}
        name={name}
        type={type}
        autoComplete={autoComplete}
        required={required}
        minLength={minLength}
        aria-invalid={error ? 'true' : undefined}
      />
      {error ? (
        <p className="text-xs text-[color:var(--color-error)]">{error}</p>
      ) : hint ? (
        <p className="text-xs text-[color:var(--fg-tertiary)]">{hint}</p>
      ) : null}
    </div>
  );
}
